var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 52.0841V77.5841C20.25 79.9301 22.1583 81.8341 24.5 81.8341H47.6793V52.0841H20.25Z",
    fill: "#39B980"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.75 35.0841H66.303C67.2678 34.4253 68.0965 33.7708 68.6745 33.1843C72.1043 29.7376 72.1043 24.1276 68.6745 20.6808C65.3425 17.3233 59.537 17.3318 56.2093 20.6808C54.3648 22.5296 49.4773 30.0563 50.153 35.0841H49.847C50.5185 30.0563 45.631 22.5296 43.7908 20.6808C40.4588 17.3318 34.6533 17.3318 31.3255 20.6808C27.9 24.1276 27.9 29.7376 31.3213 33.1843C31.9035 33.7708 32.7323 34.4253 33.697 35.0841H20.25C17.9083 35.0841 16 36.9923 16 39.3341V45.7091C16 46.8821 16.952 47.8341 18.125 47.8341H47.6794V39.3341H52.3207V47.8341H81.875C83.048 47.8341 84 46.8821 84 45.7091V39.3341C84 36.9923 82.096 35.0841 79.75 35.0841ZM45.4993 34.9438C45.4993 34.9438 45.3208 35.0841 44.713 35.0841C41.7763 35.0841 36.1705 32.0326 34.3388 30.1881C32.558 28.3946 32.558 25.4706 34.3388 23.6771C35.2015 22.8101 36.3448 22.3341 37.5603 22.3341C38.7715 22.3341 39.9148 22.8101 40.7775 23.6771C43.642 26.5586 46.4895 33.9196 45.4993 34.9438ZM55.2828 35.0841C54.6793 35.0841 54.5008 34.9481 54.5008 34.9438C53.5105 33.9196 56.358 26.5586 59.2225 23.6771C60.9353 21.9473 63.9315 21.9388 65.6613 23.6771C67.4463 25.4706 67.4463 28.3946 65.6613 30.1881C63.8295 32.0326 58.2238 35.0841 55.2828 35.0841Z",
    fill: "#39B980"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3206 52.0841V81.8341H75.4999C77.8459 81.8341 79.7499 79.9301 79.7499 77.5841V52.0841H52.3206Z",
    fill: "#39B980"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.ad8068f47398e0506013e5d87d3910c3.svg";
export { ForwardRef as ReactComponent };